export const FacebookUrl = 'https://www.facebook.com/TalenteerAI';
export const TwitterUrl = 'https://twitter.com/Talenteer_AI';
export const LinkedinUrl = 'https://www.linkedin.com/products/itransition-talenteer';
